export const samplesGridToolTipOldValuePreamble = 'Ursprünglich: ';
export const samplesGridToolTipOldValueEmpty = '&lt;leer&gt;';
